import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, StarActiveIcon, SettingsIcon, AssignIcon } from 'assets/icons';
import { ReferralService } from 'services';
import moment from 'moment';
import ModalSettings from './modal-settings';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {

}

class Referrals extends React.Component<Props> {

	state = {
		header: [
			'Fecha',
			'Usuario',
			'Referido',
			'Monto',
			'Estatus',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		referral_settings: null,
		visible_config: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Referidos',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReferralService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			referral_settings: res.referral_settings,
			data: res.referrals?.rows || [],
			last_page: res.referrals?.count || 0,
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	config = () => {
		this.setState({
			visible_config: true
		});
	}

	onCloseConfig = () => {
		this.setState({
			visible_config: false
		},() => this.load(true));
	}

	changeStatus = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm(`¿Desea marcar el referido como pagado?`,async () => {
			await ReferralService.admin.changeStatus({
				referral_id: item.id
			});
			this.load(true);
			Globals.showSuccess("Se han guardado los cambios");
		});
	}

	getColor = (item: any) => {
		switch(item.status) {
			case Constants.REFERRAL_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.REFERRAL_STATUS.PAID:
				return Colors.green_light;
			break;
		}
	}

	render() {
		const { visible_config } = this.state;

		return (
			<div id="admin-referrals">
				<Modal
		          className="modal-referral-settings"
		          visible={ visible_config }
		          title="Configuración"
		          onClose={ () => this.onCloseConfig() }
		        >
		          <ModalSettings
		          	item={ this.state.referral_settings }
		            onClose={ () => this.onCloseConfig() } />
		      	</Modal>

				<button className="btn btn-settings" onClick={ this.config }>
					<img src={ SettingsIcon } />
					<p>Configuración</p>
				</button>

				<Table title="Referidos" data={ this.state.data.length } header={ this.state.header } rightAlign={ [5] }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i.user?.name } { i.user?.lastname }</td>
								<td>{ i.user_referral?.name } { i.user_referral?.lastname }</td>
								<td>{ Globals.formatMiles(i.amount) }</td>
								<td className="status" style={{ color: this.getColor(i) }}>{ i.status_text }</td>
								<td style={{ 'whiteSpace': 'nowrap', textAlign: 'right' }}>
									{
										i.status == Constants.REFERRAL_STATUS.PENDING && (
											<Tooltip title="Marcar como pagado">
												<a className="link-icon" href="#" onClick={ (e: any) => this.changeStatus(e,i) }>
													<img src={ AssignIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Referrals);